export default __webpack_public_path__ + "static/media/Black.e7f25d6f.mp3";